var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg147Medal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M483.624,28.855c3.062-6.199,2.704-13.54-0.945-19.412S472.606,0,465.692,0H336.309c-7.612,0-14.563,4.32-17.933,11.145 l-79.841,161.677c-29.485,2.901-56.784,13.366-79.922,29.425L78.491,40h84.772l32.114,65.031 c4.891,9.904,16.883,13.967,26.788,9.077c9.904-4.891,13.968-16.884,9.077-26.788l-37.617-76.175 C190.255,4.32,183.303,0,175.692,0H46.309c-6.914,0-13.338,3.571-16.988,9.443c-3.649,5.872-4.007,13.213-0.945,19.412 l98.766,200c0.165,0.335,0.339,0.663,0.52,0.984C101.31,259.793,85.309,299.063,85.309,342c0,93.738,76.262,170,170,170 c31.268,0,61.841-8.567,88.413-24.776c9.43-5.752,12.411-18.059,6.659-27.489c-5.753-9.431-18.06-12.413-27.489-6.66 c-20.297,12.38-43.667,18.924-67.585,18.924c-71.683,0-130-58.318-130-130s58.317-130,130-130s130,58.318,130,130 c0,17.11-3.266,33.729-9.707,49.396c-4.199,10.216,0.678,21.903,10.894,26.103c10.216,4.2,21.904-0.678,26.103-10.894 c8.435-20.516,12.711-42.252,12.711-64.604c0-42.49-15.67-81.39-41.533-111.223c0.392-0.614,0.753-1.255,1.083-1.922 L483.624,28.855z M353.032,202.966c-20.626-14.54-44.616-24.612-70.551-28.796L348.738,40h84.771L353.032,202.966z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.309,414c11.046,0,20-8.954,20-20V292c0-11.046-8.954-20-20-20h-35c-11.046,0-20,8.954-20,20 c0,11.046,8.954,20,20,20h15v82C236.309,405.046,245.263,414,256.309,414z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg147Medal);
export default __webpack_public_path__ + "static/media/147-medal.aa882b81754d3f166caa34c3d94a389e.svg";
export { ForwardRef as ReactComponent };